import * as React from "react"

import { Icons } from "@/components/icons"

interface RenderIconProps {
  connectionStatus: string
}

// Status colors without blinking
const statusColors: { [key: string]: string } = {
  Active: "#00C853",
  Delinquent: "#FFA000",
  Disconnected: "#F44336",
  "Before Due": "#9C27B0",
  "Due Today": "#E91E63",
  "Over Due": "#AD1457",
  Disconnection: "#673AB7",
}

export function MapIcon({ connectionStatus }: RenderIconProps) {
  const color = statusColors[connectionStatus] || "#2196F3" // pending status default color

  return (
    <div className="relative" style={{ width: 24, height: 24 }}>
      {/* Outer ring/glow effect - heatmap style */}
      <div
        className="absolute inset-0 animate-pulse rounded-full"
        style={{
          backgroundColor: color,
          opacity: 0.3,
          filter: "blur(4px)",
          transform: "scale(1.5)",
        }}
      />

      {/* Inner ring for extra definition */}
      <div
        className="absolute inset-0 rounded-full"
        style={{
          border: `2px solid ${color}`,
          opacity: 0.6,
          transform: "scale(1.2)",
        }}
      />

      {/* Main icon */}
      <div className="absolute inset-0 flex items-center justify-center">
        <Icons.user fill={color} size={20} />
      </div>
    </div>
  )
}
